import React, {forwardRef} from "react";

const Receipt = forwardRef((props, ref) => {

    const app = props.state.application;
    const payment = app.payments[0];

    if (!payment)
        return null;

    return (
        <div ref={ref}>
            <h1>Kvitto startavgift Kanallöpet</h1>
            <br/>
            OK Skogsströvarna<br/>
            Ljungsbro Olstorp 1<br/>
            58572 Ljungsbro<br/>
            info@okskogsstrovarna.se<br/>
            https://www.okroxen.se/moderklubbarna/ok-skogsstrovarnaolstorp/<br/>
            Org-nr:822001-2895<br/>
            <br/>
            <br/>

            <table>
                <tbody>
                {
                    app.runners.map((a, i) => {
                        if (a.status === 'Borttagen') {
                            return null;
                        }
                        return (
                            <>
                                <tr key={a.id}>
                                    <td colSpan="2">
                                        {a.lateApply ? 'Efteranmälan' : 'Anmälan'} {a.competitionClass.name} för {a.firstName} {a.lastName}
                                    </td>
                                    <td width="30"></td>
                                    <td>{a.exbusfee} kr</td>
                                </tr>
                                {
                                    a.bus ? (
                                        <tr>
                                            <td colSpan="2">Busstransport för {a.firstName} {a.lastName}</td>
                                            <td></td>
                                            <td>{a.busfee} kr</td>
                                        </tr>
                                    ) : ''
                                }
                            </>
                        )
                    })
                }

                <tr>
                    <td colSpan="4">&nbsp;</td>
                </tr>
                <tr>
                    <td>Intern referens:</td>
                    <td width="30"></td>
                    <td></td>
                    <td>{app.reference}</td>
                </tr>
                <tr>
                    <td>{payment.type === 'swish' ? 'Swish' : 'Betal'}referens:</td>
                    <td width="30"></td>
                    <td></td>
                    <td>{payment.paymentReference}</td>
                </tr>
                <tr>
                    <td>Transaktionsdatum:</td>
                    <td width="30"></td>
                    <td></td>
                    <td>{(new Date(payment.date)).toLocaleDateString() + ' ' + (payment.time || '')}</td>
                </tr>
                <tr>
                    <td colSpan="4">&nbsp;</td>
                </tr>
                <tr>
                    <td><b>Totalbelopp:</b></td>
                    <td width="30"></td>
                    <td></td>
                    <td><b>{app.fee} kr</b></td>
                </tr>
                <tr>
                    <td colSpan="4">&nbsp;</td>
                </tr>
                <tr>
                    <td>Moms:</td>
                    <td width="30"></td>
                    <td></td>
                    <td>Föreningen är momsbefriad</td>
                </tr>
                </tbody>
            </table>
        </div>
    );
})

export default Receipt;